import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import { makeStyles, Theme } from '@material-ui/core'
import React, { FC } from 'react'

import { usePPLContext } from '../PPLProvider'
import NonMSEditableProperty from './editNonMS/NonMSEditableProperty'
import NonMSModeSelector from './NonMSModeSelector'

const useStyles = makeStyles((theme: Theme) => ({
    modeContainer: {
        marginBottom: theme.spacing(4.625),
    },
}))

const NonMSModeContainer: FC = () => {
    const { nonMSProperties: state } = usePPLContext()

    const mode = state?.mode ?? ''
    const classes = useStyles()

    return (
        <GridContainer className={classes.modeContainer}>
            {!mode && <NonMSModeSelector />}
            {!!mode && <NonMSEditableProperty />}
        </GridContainer>
    )
}

export default NonMSModeContainer
